export function initializeResizeObserver() {
  const headerNav = document.getElementById("nav");

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const width = entry.contentRect.width;
      if (width >= 1280) {
        headerNav.removeAttribute("style");
      }
    }
  });

  // Observe the document's body element for size changes
  resizeObserver.observe(document.body);

  // Trigger the observer manually on load to ensure it starts with correct state
  if (document.body.clientWidth >= 1280) {
    headerNav.removeAttribute("style");
  }
}
